<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">规格名称：</label>
        <el-input class="input-box" placeholder="规格名称" v-model="queryParams.name" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button v-if="$hasPermission('A30601')" type="success" icon="el-icon-plus" @click="openDialog()">新增规格</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
      <el-table-column prop="sortNum" label="排序" width="80" align="center"></el-table-column>
      <el-table-column prop="name" label="规格名称" min-width="120" align="center"></el-table-column>
      <el-table-column prop="description" label="描述" min-width="140" align="center"></el-table-column>
      <el-table-column label="价格(元)" width="100" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.fee) }}</template>
      </el-table-column>
      <el-table-column prop="specId" label="规格ID" width="90" align="center"></el-table-column>
      <el-table-column label="像素" width="130" align="center">
        <template slot-scope="scope">{{ scope.row.specWidth }} × {{ scope.row.specHeght }}</template>
      </el-table-column>
      <el-table-column prop="specSize" label="尺寸" width="120" align="center"></el-table-column>
      <el-table-column prop="bgColor" label="背景色" width="110" align="center"></el-table-column>
      <el-table-column prop="specFileSize" label="大小(KB)" width="100" align="center"></el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('A30602')" type="primary" size="mini" plain @click="openDialog(scope.row)">编辑</el-button>
          <el-button v-if="$hasPermission('A30603')" type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="form.id ? '编辑相片规格' : '新增相片规格'" :visible.sync="dialogVisible" width="560px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="规格名称">
          <el-input v-model="form.name" placeholder="规格名称" @keyup.enter.native="save()"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortNum" :min="0" :precision="0" :controls="true" style="width: 100%;"></el-input-number>
          <div style="color: #909399; font-size: 12px; line-height: 18px;">数字越小越靠前，新增留空或 0 时自动排到末尾</div>
        </el-form-item>
        <el-form-item label="规格描述">
          <el-input v-model="form.description" placeholder="规格描述"></el-input>
        </el-form-item>
        <el-form-item label="价格(元)">
          <el-input-number v-model="form.feeYuan" :min="0" :precision="2" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="规格ID">
          <el-input-number v-model="form.specId" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="宽度(px)">
          <el-input-number v-model="form.specWidth" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="高度(px)">
          <el-input-number v-model="form.specHeght" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="规格尺寸">
          <el-input v-model="form.specSize" placeholder="如 25mm*35mm"></el-input>
        </el-form-item>
        <el-form-item label="背景色">
          <el-input v-model="form.bgColor" placeholder="如 纯白色"></el-input>
        </el-form-item>
        <el-form-item label="文件大小(KB)">
          <el-input-number v-model="form.specFileSize" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, name: '' },
      sourceList: [],
      tableData: [],
      dialogVisible: false,
      form: {}
    }
  },
  created() { this.GetData() },
  methods: {
    emptyForm() {
      return {
        name: '',
        description: '',
        feeYuan: 0,
        specId: 0,
        specWidth: 0,
        specHeght: 0,
        specSize: '',
        bgColor: '',
        specFileSize: 0,
        sortNum: 0
      }
    },
    yuanToFen(value) {
      return Math.round((Number(value) || 0) * 100)
    },
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    GetData() {
      const loading = this.openLoading()
      post(224, { name: (this.queryParams.name || '').trim() })
        .then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.sourceList = Array.isArray(response.data.data) ? response.data.data : []
            this.applyMockPage(this.sourceList)
          } else {
            this.sourceList = []
            this.applyMockPage([])
            this.$message.error('查询失败：' + response.data.message)
          }
        })
        .catch(error => {
          loading.close()
          this.sourceList = []
          this.applyMockPage([])
          this.$message.error((error && error.userMessage) || '查询失败')
        })
    },
    handleCurrentChange() {
      this.applyMockPage(this.sourceList)
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.pageIndex = 1
      this.applyMockPage(this.sourceList)
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name || '',
          description: row.description || '',
          feeYuan: (Number(row.fee) || 0) / 100,
          specId: row.specId || 0,
          specWidth: row.specWidth || 0,
          specHeght: row.specHeght || 0,
          specSize: row.specSize || '',
          bgColor: row.bgColor || '',
          specFileSize: row.specFileSize || 0,
          sortNum: Number(row.sortNum) || 0
        }
      } else {
        this.form = this.emptyForm()
      }
      this.dialogVisible = true
    },
    save() {
      const name = (this.form.name || '').trim()
      if (!name) {
        this.$message.error('规格名称不能为空')
        return
      }
      if (this.form.feeYuan < 0) {
        this.$message.error('价格不能小于0')
        return
      }
      if (this.form.sortNum < 0) {
        this.$message.error('排序号不能小于0')
        return
      }

      const isEdit = !!this.form.id
      const payload = {
        name,
        description: (this.form.description || '').trim(),
        fee: this.yuanToFen(this.form.feeYuan),
        specId: Number(this.form.specId) || 0,
        specWidth: Number(this.form.specWidth) || 0,
        specHeght: Number(this.form.specHeght) || 0,
        specSize: (this.form.specSize || '').trim(),
        bgColor: (this.form.bgColor || '').trim(),
        specFileSize: Number(this.form.specFileSize) || 0,
        sortNum: Number(this.form.sortNum) || 0
      }
      if (isEdit) payload.id = this.form.id

      const loading = this.openLoading()
      post(isEdit ? 226 : 225, payload).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isEdit ? '修改成功' : '添加成功')
          this.dialogVisible = false
          this.GetData()
        } else {
          this.$message.error((isEdit ? '修改失败：' : '添加失败：') + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || (isEdit ? '修改失败' : '添加失败'))
      })
    },
    remove(row) {
      this.$confirm(`确认删除相片规格「${row.name}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(227, { objId: row.id })
          .then(response => {
            loading.close()
            if (response.data.result == 0) {
              this.$message.success('删除成功')
              if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
                this.queryParams.pageIndex -= 1
              }
              this.GetData()
            } else {
              this.$message.error('删除失败：' + response.data.message)
            }
          })
          .catch(error => {
            loading.close()
            this.$message.error((error && error.userMessage) || '删除失败')
          })
      }).catch(() => {})
    }
  }
}
</script>
